const DeleteAccountIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path d='M5 7h14M5 12h14M5 17h10' stroke='currentColor' strokeWidth='1.6' />
    <path
      d='M18 17l3 3m0-3l-3 3'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinecap='round'
    />
  </svg>
);

export default DeleteAccountIcon;
